import React, { Component, useMemo } from "react";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import { Button } from "react-bootstrap";

function DataGridAmusementServices({ data, setSelectedComplexId, setShowModalAmusementsOrder }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "name",
      Header: "نام",
      minWidth: "100px",
    },
    {
      accessor: "urlName",
      Header: "urlName",
      minWidth: "100px",
    },

    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "100px",
      Cell: ({ row }) => {
        const regionNames = row.original.amusementComplexRegions?.map((rgn) => rgn.region.name).join("، ");
        return regionNames;
      },
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.status ? true : false}
            //checked={state.checkedA}
            value="row.original.active"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            // onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Link
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            to={`/createEditAmusementComplex/${row.original.id}`}
          >
            <i className="far fa-edit text-small"></i>
          </Link>
          {/* ترتیب سرویس ها در هر مجتمع*/}
          <Button
            title="ترتیب نمایش"
            className="btn btn-light-success btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedComplexId(row.original.id);
              setShowModalAmusementsOrder(true);
            }}
          >
            <i className="fas fa-sort-up text-small"></i>
            <i className="fas fa-sort-down text-small"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
